<template>
    <div class="checkbox-container d-flex align-items-center justify-content-center" :class="containerClass">
        <input type="checkbox"
            :value="val"
            :disabled="disabled"
            :id="id"
            v-model="checked"
            @change="onChange">
    </div>
</template>
<script>
export default {

    props:{
        value: false,   // element prop value
        val: false,     // set from parent template

        disabled:{
            default: false,
            type: Boolean
        },
        id: {
            default: false
        }
    },
    data: function() {
        return {
            checkedProxy: false
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkedProxy = val
            }
        }
    },
    data:() => {
        return {
            containerClass: ""
        }
    },
    methods:{
        onChange: function(e) {
            this.$emit('input', this.checkedProxy);
        }
    }
}
</script>
